import { textfield } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'textfield',
  label: 'Textfield',
  category: 'Inputs',
  image: textfield
};
